// Форматирование для строк интерфейса (ADR-0026, narrative/03 §9): склонение с числом, разряды, таймеры.
export function plural(n: number, one: string, few: string, many: string): string {
  const a = Math.abs(n) % 100;
  const b = a % 10;
  if (a > 10 && a < 20) return many;
  if (b === 1) return one;
  if (b >= 2 && b <= 4) return few;
  return many;
}

/** «12 500» с неразрывным узким пробелом между разрядами. */
export function num(n: number): string {
  return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/** Компактный формат шапки ADR-0026 от 10 000: «12,5к», «1,2млн» (ux/03 §1.1). */
export function compact(n: number): string {
  const a = Math.abs(n);
  const sign = n < 0 ? '−' : '';
  const f = (x: number) => (Math.floor(x * 10) / 10).toString().replace('.', ',');
  if (a >= 1_000_000) return `${sign}${f(a / 1_000_000)}млн`;
  if (a >= 10_000) return `${sign}${f(a / 1000)}к`;
  return `${sign}${num(a)}`;
}

/** Таймер «2:14» или «1:02:14». */
export function timer(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = String(s % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
}

/** Длительность «2 ч 06 мин» / «42 мин» / «15 с». */
export function duration(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  if (s < 60) return `${s} с`;
  const m = Math.ceil(s / 60);
  if (m < 60) return `${m} мин`;
  return `${Math.floor(m / 60)} ч ${String(m % 60).padStart(2, '0')} мин`;
}

/** Время по Москве «15:00» (канон §12: время сброса и техработ — МСК). */
export function mskTime(ms: number): string {
  return new Date(ms).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow' });
}

export const CURRENCY: Record<string, { name: string; gen: [string, string, string]; icon: string }> = {
  energy: { name: 'Энергия', gen: ['энергия', 'энергии', 'энергии'], icon: '⚡' },
  nuts: { name: 'Гайки', gen: ['гайка', 'гайки', 'гаек'], icon: '🔩' },
  talons: { name: 'Талоны', gen: ['талон', 'талона', 'талонов'], icon: '🎫' },
  diesel: { name: 'Солярка', gen: ['л солярки', 'л солярки', 'л солярки'], icon: '🛢' },
  scrap: { name: 'Лом', gen: ['лом', 'лома', 'лома'], icon: '⚙' },
  keys: { name: 'Ключи', gen: ['ключ', 'ключа', 'ключей'], icon: '🔑' },
  tickets: { name: 'Билеты', gen: ['билет', 'билета', 'билетов'], icon: '🎟' },
  xp: { name: 'Опыт', gen: ['опыт', 'опыта', 'опыта'], icon: '★' },
};

export function amount(code: string, n: number): string {
  const c = CURRENCY[code];
  if (!c) return `${num(n)} ${code}`;
  return `${num(n)} ${plural(n, ...c.gen)}`;
}
